import type { FunctionComponent } from "react";
import { EndCampaignModalPartial } from "../../../../partials/admin/menus/campaign/end-campaign.modal.admin.partials";

export const EndCampaignModalAdminScreen: FunctionComponent = () => {
	return <EndCampaignModalPartial />;
};
